
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as gg1_XtGAkrHftUeuMl5TR8vLcktXGyvBhN3mr8TBrsu4Meta } from "/codebuild/output/src2074274046/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indexttEXY5Xknmw2LnIrKdp8Kc2gHcm_cZ7A1_45fsAhOFU5QMeta } from "/codebuild/output/src2074274046/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchuYeoFQ1LJq_45QUAFKYOmsHF_d4tdOEX5AdnADU7TpiwgMeta } from "/codebuild/output/src2074274046/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexYQnoKRtMbq7uc_45ZO8eUGqjPSlapJoO_45JO8dyXmRL_eUMeta } from "/codebuild/output/src2074274046/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93MXo04d4aDGoUG_GYt0_45vp2SzSi30HEYMHLOwO9o1TScMeta } from "/codebuild/output/src2074274046/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as index7uCsmBuWxWlCMWGExWOePiH4Fm44gfIgQ73txGJm5JAMeta } from "/codebuild/output/src2074274046/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93Mbco3K2_45n8SMUCckvZmDidSWSpN_QpquzzPZH4y6NMEMeta } from "/codebuild/output/src2074274046/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indexays_bLGJqUDg2hy_FuQGFfCgDayMG4Bmb1ZYLOycJMsMeta } from "/codebuild/output/src2074274046/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93JsPQA4WUUtqxXjEERwawxFnmUpjRvd1mQojM3OHIYpYMeta } from "/codebuild/output/src2074274046/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indexvS06kcTo2veuhgeaCyHLQCRnPMv8AFJYuF71QH9fm0QMeta } from "/codebuild/output/src2074274046/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexnWy_45yyU5_pcnHfCKFNVeDuHxksm7ZOiKI8H1xqiNHlAMeta } from "/codebuild/output/src2074274046/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src2074274046/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src2074274046/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src2074274046/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src2074274046/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src2074274046/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: index7uCsmBuWxWlCMWGExWOePiH4Fm44gfIgQ73txGJm5JAMeta || {},
    component: () => import("/codebuild/output/src2074274046/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src2074274046/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexays_bLGJqUDg2hy_FuQGFfCgDayMG4Bmb1ZYLOycJMsMeta || {},
    component: () => import("/codebuild/output/src2074274046/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src2074274046/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indexvS06kcTo2veuhgeaCyHLQCRnPMv8AFJYuF71QH9fm0QMeta || {},
    component: () => import("/codebuild/output/src2074274046/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexnWy_45yyU5_pcnHfCKFNVeDuHxksm7ZOiKI8H1xqiNHlAMeta || {},
    component: () => import("/codebuild/output/src2074274046/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]